import { RouterProvider, createRootRoute, createRoute, createRouter } from "@tanstack/react-router";
import { Layout } from "./components/layout/Layout";
import { AboutPage } from "./pages/AboutPage";
import { ContactsPage } from "./pages/ContactsPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { OrdersPage } from "./pages/OrdersPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { ProductsPage } from "./pages/ProductsPage";

const rootRoute = createRootRoute({ component: Layout, notFoundComponent: NotFoundPage });
const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: "/", component: HomePage });
const productsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/produtos", component: ProductsPage });
const ordersRoute = createRoute({ getParentRoute: () => rootRoute, path: "/encomendas", component: OrdersPage });
const aboutRoute = createRoute({ getParentRoute: () => rootRoute, path: "/sobre", component: AboutPage });
const contactsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/contactos", component: ContactsPage });
const privacyRoute = createRoute({ getParentRoute: () => rootRoute, path: "/politica-de-privacidade", component: PrivacyPage });

const routeTree = rootRoute.addChildren([indexRoute, productsRoute, ordersRoute, aboutRoute, contactsRoute, privacyRoute]);
const router = createRouter({ routeTree, defaultPreload: "intent", scrollRestoration: true });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  return <RouterProvider router={router} />;
}
